/**
 * Every keyboard shortcut the app offers, grouped by where it applies.
 *
 * Global shortcuts work on every page. Page shortcuts only work on pages that declare them
 * in their PageMeta `Meta.shortcuts`, which is also what the shortcut list shows for that page.
 * Key bindings and labels live with the app's shortcut registry.
 */
/* eslint-disable no-unused-vars -- Core ESLint flags TypeScript enum members. */
export enum GlobalShortcut {
  ShowShortcuts = 'global.showShortcuts',
  ToggleNavigation = 'global.toggleNavigation',
}

export enum AiWorkspaceShortcut {
  NewChat = 'aiWorkspace.newChat',
  FocusComposer = 'aiWorkspace.focusComposer',
  ToggleChats = 'aiWorkspace.toggleChats',
  RateResponse = 'aiWorkspace.rateResponse',
}
/* eslint-enable no-unused-vars */

export type KeyboardShortcutId = GlobalShortcut | AiWorkspaceShortcut
